import React, { FunctionComponent } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { CustomInput } from "../../../CustomInput";
import { ISectionProps } from "../ISectionProps";
import { IMarketSharpState } from "../../IState";
import { useNewInput } from "../../new-input.hook";
import { Button } from "../../../Button";
import { NewInputDialog } from "../NewInputDialog";

export const MarketSharpSection: FunctionComponent<ISectionProps<IMarketSharpState>> = (props) => {
    const {
        data,
        onChange
    } = props;

    const { isNewInputDialogOpen, toggleNewInputDialog } = useNewInput();

    return (
        <Box ml={2} mt={1} >
            <Typography sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 18, mb: 1 }} >
                MarketSharp
            </Typography>
            <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                <CustomInput
                    value={data.coy}
                    width={"100%"}
                    height={35}
                    label={{ text: "COY", color: "rgba(0, 0, 0, 0.8)" }}
                    name="coy"
                    placeholder="coy"
                    onChange={onChange}
                />
                <CustomInput
                    value={data.formKey}
                    width={"100%"}
                    height={35}
                    label={{ text: "Form Key", color: "rgba(0, 0, 0, 0.8)" }}
                    name="formKey"
                    placeholder="form key"
                    onChange={onChange}
                />
                <CustomInput
                    value={data.sourceKey}
                    width={"100%"}
                    height={35}
                    label={{ text: "Source Key", color: "rgba(0, 0, 0, 0.8)" }}
                    name="sourceKey"
                    placeholder="source key"
                    onChange={onChange}
                />
                <CustomInput
                    value={data.captureName}
                    width={"100%"}
                    height={35}
                    label={{ text: "Capture Name", color: "rgba(0, 0, 0, 0.8)" }}
                    name="captureName"
                    placeholder="capture name"
                    onChange={onChange}
                />
                <CustomInput
                    value={data.defaultSource}
                    width={"100%"}
                    height={35}
                    label={{ text: "Default Source", color: "rgba(0, 0, 0, 0.8)" }}
                    name="defaultSource"
                    placeholder="default source"
                    onChange={onChange}
                />
                {
                    props.fields.map((field, index) => {
                        const objName = Object.keys(field)[0] as keyof typeof field;

                        return (
                            <CustomInput
                                width={220}
                                height={35}
                                label={{ text: objName.toString() }}
                                name={objName.toString()}
                                value={field[objName]}
                                onChange={(event) => props.onChangeField(event as React.ChangeEvent<HTMLInputElement>, index)}
                            />
                        )
                    })
                }
            </Box>
            <Box mt={2} >
                <Button label="Add new field" width={120} height={35} onClick={toggleNewInputDialog} />
            </Box>
            <NewInputDialog
                open={isNewInputDialogOpen}
                onClose={toggleNewInputDialog}
                onClick={(name, value) => {
                    props.onAdd(name, value);
                    toggleNewInputDialog();
                }}
            />
        </Box>
    )
}